import script from "./ScheduleNotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleNotificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ScheduleNotificationModal.vue?vue&type=style&index=0&id=30476ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30476ef0"]])

export default __exports__